module.exports = __webpack_public_path__ + "img/Menu-15.53371b78.webp";